@for (summary of discountSummary; track summary) {
  <se-fe-card-content>
    <div [innerHtml]="summary"></div>
  </se-fe-card-content>
}
